import {
    makeSelectWrapper,
    NumberCol,
    RenderStringCol,
    SelectCol,
    Table,
    ViewOnly
} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {DoorCore, DoorSeam} from "../../../../api/Openings";
import React, {useContext} from "react";
import {useIsQuote} from "../QuoteContainer";
import {useAlternative} from "../alternative/Alternative";
import {FileCol} from "../../settings/FileCol";
import {DropDownContext, useDropdownData} from "../../settings/DropDowns";
import {CircularProgress} from "@mui/material";

export function ReviewDoorSeam() {
    const project = useProjectId();
    const sys = useProjectUnitSystem();
    const isQuote = useIsQuote();
    const alt = useAlternative();

    const ddl = useContext(DropDownContext);
    const doorSeamOptions = useDropdownData(ddl.doorSeam);

    if(ddl.loading || !sys) {
        return <CircularProgress />
    }

    return (
        <Table<DoorSeam>
            name={"door-seams"}
            fetch={ctx => {
                return isQuote ? api.quoteOpenings.listDoorSeams({
                        project: project,
                        alternative: alt,
                    }) : api.openings.listDoorSeams({
                        project: project,
                    });
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                SelectCol<DoorCore>("Door Seam", "doorSeam", makeSelectWrapper(doorSeamOptions)),
                ViewOnly(NumberCol("Qty", "count")),
                FileCol<DoorSeam>("Attachment", "doorSeamFile", "doorSeamFileName"),
                RenderStringCol("-", () => ""),
            ]}
            onChange={input => {
                if(isQuote) {
                    return api.quoteOpenings.upsertDoorSeam(input);
                }

                return api.openings.upsertDoorSeam(input);
            }}
        />
    )
}